module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: 'awaiting awaiting-' + (_vm.static ? 'static' : '')
  }, [_c('div', {
    class: 'text ' + (_vm.show ? 'visible' : '')
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('br'), _vm._v(" "), _vm._m(0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-dots dark-gray"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733f8dbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Loading.vue
// module id = 977
// module chunks = 0